import { ISpinButtonProps, Position, SpinButton } from '@fluentui/react';
import { makeStyles, Typography } from '@material-ui/core';
import { theme } from 'tailwind.config';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import { MergeField } from '../../type';
import { MAX_DAYS } from '../../constants';
import LightTooltip from '../LightTooltip';

const spinButtonStyles = {
  spinButtonWrapper: [
    {
      height: 32,
      '&::after': {
        borderColor: theme.colors['neutral/200'],
        borderRadius: 4,
      },
    },
  ],
  arrowButtonsContainer: [
    {
      width: 30,
      '& button': {
        width: '100%',
        color: theme.colors['clari-blue/500'],
      },
    },
  ],
};

const useStyles = makeStyles({
  label: {
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
  },
  infoIcon: {
    fontSize: 12,
    paddingLeft: 5,
  },
});

interface NonSFDCTodayPlusNProps {
  mergeField: MergeField;
  daysToAdd: number;
  onChange: ISpinButtonProps['onChange'];
}

export const NonSFDCTodayPlusN = ({
  mergeField,
  daysToAdd,
  onChange,
}: NonSFDCTodayPlusNProps): JSX.Element => {
  const classes = useStyles({});

  return (
    <>
      <Typography variant="caption" className={classes.label}>
        Number of days
        <LightTooltip
          arrow
          title="The dates are evaluated at time of send and may be different from what is shown"
          placement="top"
        >
          <InfoIcon className={classes.infoIcon} />
        </LightTooltip>
      </Typography>
      <SpinButton
        styles={spinButtonStyles}
        id={mergeField.name}
        value={`+${daysToAdd}`}
        min={1}
        max={MAX_DAYS[mergeField.name]}
        labelPosition={Position.top}
        ariaLabel={mergeField.label}
        incrementButtonAriaLabel={`Increase ${mergeField.label}`}
        decrementButtonAriaLabel={`Decrease ${mergeField.label}`}
        onChange={onChange}
        data-testid="number-of-days-input"
      />
    </>
  );
};
